module.exports = __webpack_public_path__ + "media/normalto.8eec34f8.mp4";